import React from 'react'
import { motion } from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const { FiX, FiUser } = FiIcons

const PhotoModal = ({ person, isOpen, onClose }) => {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose()
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        className="relative max-w-4xl max-h-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-60 text-white p-2 rounded-full hover:bg-opacity-80 transition-opacity"
          aria-label="Close photo"
        >
          <SafeIcon icon={FiX} size={24} />
        </button>

        {/* Person Name */}
        <div className="absolute top-4 left-4 z-10 bg-black bg-opacity-60 text-white px-4 py-2 rounded-lg">
          <h3 className="font-medium text-lg">{person.name}</h3>
        </div>

        {/* Photo */}
        <div className="flex items-center justify-center">
          {person.photo_url ? (
            <img
              src={person.photo_url}
              alt={person.name}
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
              onError={(e) => {
                // If image fails to load, show fallback
                e.target.style.display = 'none'
                e.target.nextSibling.style.display = 'flex'
              }}
            />
          ) : null}
          
          {/* Fallback if no photo or image fails */}
          <div 
            className="bg-gray-700 text-white rounded-lg p-12 flex flex-col items-center justify-center"
            style={{ display: person.photo_url ? 'none' : 'flex' }}
          >
            <SafeIcon icon={FiUser} className="text-6xl mb-4 text-gray-400" />
            <p className="text-xl font-medium text-gray-300">{person.name}</p>
            <p className="text-gray-400 mt-2">No photo available</p>
          </div>
        </div>

        {/* Instructions */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-60 text-white px-4 py-2 rounded-lg text-sm">
          Click outside or press ESC to close
        </div>
      </motion.div>
    </motion.div>
  )
}

export default PhotoModal